export const signUpActions = {
  checkCompanyType: 'CHECK_ONE_FOR_COMPANY_TYPE',
  uncheckCompanyType: 'UNCHECK_ONE_FOR_COMPANY_TYPE',
  clearSignUpStore: 'CLEAR_SIGNUP_REDUCER',
  updateSignUpProps: 'UPDATE_SIGN_UP_PROPS',
  companyNameSearchStarting: 'COMPANY_NAME_SEARCH_STARTING',
  companyNameSearchFinished: 'COMPANY_NAME_SEARCH_FINISHED',
  signUpUserStarting: 'SIGN_UP_USER_STARTING',
  signUpUserFinished: 'SIGN_UP_USER_FINISHED',
  showSignUpErrorString: 'SHOW_SIGN_UP_ERROR_STRING',
};

export const CHECK_ONE_FOR_COMPANY_TYPE = 'CHECK_ONE_FOR_COMPANY_TYPE';
export const UNCHECK_ONE_FOR_COMPANY_TYPE = 'UNCHECK_ONE_FOR_COMPANY_TYPE';
export const CLEAR_SIGNUP_REDUCER = 'CLEAR_SIGNUP_REDUCER';
export const UPDATE_SIGN_UP_PROPS = 'UPDATE_SIGN_UP_PROPS';
export const COMPANY_NAME_SEARCH_STARTING = 'COMPANY_NAME_SEARCH_STARTING';
export const COMPANY_NAME_SEARCH_FINISHED = 'COMPANY_NAME_SEARCH_FINISHED';
export const SIGN_UP_USER_STARTING = 'SIGN_UP_USER_STARTING';
export const SIGN_UP_USER_FINISHED = 'SIGN_UP_USER_FINISHED';
export const SHOW_SIGN_UP_ERROR_STRING = 'SHOW_SIGN_UP_ERROR_STRING';



// WEBPACK FOOTER //
// ./src/app/stores/sign-up/sign-up-constants.js